import * as moment from 'moment';
import { ReservationMode } from '../enums/reservationMode.enum';
import { Asset } from './asset.model';
import { Customer } from './customer.model';
import { Serializable } from './deserialize.service';
import { Event } from './event.model';
import { Service } from './service.model';
import { ServiceGroup } from './serviceGroup.model';
import { Subcontractor } from './subcontractor.model';

export class ReservationRequest implements Serializable<ReservationRequest> {
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    businessHours: any;
    customerForTerm: Customer;
    customTagId: number;
    disableDateChange: boolean;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    editModel: any;
    end: moment.Moment;
    event: Event;
    genericTitle: string;
    isCreateReservationFromDraft = false;
    isEditMode: boolean;
    isGenericTerm: boolean;
    isOpenReservation: boolean;
    noShow: boolean;
    popupTitle: string;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    recurringType: any;
    reservationMode: ReservationMode;
    selectedAsset: Asset;
    selectedDate: moment.Moment;
    selectedDateView: string;
    selectedService: Service;
    selectedSubcontractor: Subcontractor;
    selectedTime: string;
    selectedTimeEnd: string;
    showGenericTermDeleteButton = false;
    start: moment.Moment;
    termComment: string;
    telemed: boolean;
    phoneCall: boolean;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    oldEvent: any;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    hdapp: any;
    serviceGroup: ServiceGroup;
    //origin === customer --> add Validator.required for service
    origin: string | 'customer';
    // reservationType: ReservationType;
    // originDate: moment.Moment;
    // newCustomer: boolean;

    deserialize(input) {
        if (!this) {
            return;
        }
        // this.reservationType = input.reservationType;
        // // this.create = input.create;
        // this.selectedService = new Service().deserialize(input.selectedService);
        // this.selectedSubcontractor = new Subcontractor().deserialize(input.selectedSubcontractor);
        // this.selectedAsset = new Asset().deserialize(input.selectedAsset);
        // this.customerForTerm = new Customer().deserialize(input.customerForTerm);
        // this.event = new Event().deserialize(input.event);

        // this.isEditMode = input.isEditMode;
        // this.disableDateChange = input.disableDateChange;
        // this.isGenericTerm = input.isGenericTerm;
        // this.showGenericTermDeleteButton = input.showGenericTermDeleteButton;
        // this.selectedTime = input.selectedTime;
        // this.selectedTimeEnd = input.selectedTimeEnd;
        // this.popupTitle = input.popupTitle;
        // this.termComment = input.termComment;

        // this.genericTitle = input.genericTitle;
        // this.editModel = input.editModel;
        // this.selectedDate = input.selectedDate;
        // this.businessHours = input.businessHours;
        // this.customTagId = input.customTagId;
        // this.isCreateReservationFromDraft = input.isCreateReservationFromDraft;
        // this.recurringType = input.recurringType;
        // this.noShow = input.noShow;
        // this.isOpenReservation = input.isOpenReservation;

        // this.start = input.start;
        // this.end = input.end;

        return Object.assign(this, input);
        // return this;
    }
}
